import { render, staticRenderFns } from "./user-profile.vue?vue&type=template&id=c4ed7a1a&scoped=true"
import script from "./user-profile.vue?vue&type=script&lang=js"
export * from "./user-profile.vue?vue&type=script&lang=js"
import style0 from "./user-profile.vue?vue&type=style&index=0&id=c4ed7a1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ed7a1a",
  null
  
)

export default component.exports